<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Paste from Excel...</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Add
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-textarea
                style="margin-top: 15px;"
                label="Phone numbers to add to list"
                hint="You can copy and paste a column of phone numbers from excel.  Will not add the same number to the list twice."
                auto-grow
                v-on:input="update"
                v-model="text"
            >
            </v-textarea>

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.endpoint="{ item }">
                    {{$rc.pretty(item.endpoint, 'endpoint')}}
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            text: null,
            results: [],
            organization_id: null,
            headers: [
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'Name', value: 'endpoint_label'},
            ],
        }
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'PREVIEW-ADD-MULTIPLE: /api/v1/lists/members',
            
                {
                    'text' : this.text,
                    'organization_id' : this.organization_id,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete preview numbers being added to list');
                },
            );
        },
        

        showDialog(organization_id)
        {
            this.organization_id = organization_id;
            this.text = null;
            this.results = [];

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
               
            this.save();
            this.dialog = false;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            this.$emit('add', this.text);
        },

    },
}
</script>

<style lang="scss" scoped>
</style>